import { AuthOtpController } from "./AuthOtpController";
import { CamundaController } from "./CamundaController";
import { ReferenceController } from "./ReferenceController";
import { KatoController } from "./KatoController";
import axios from "axios";
import moment from "moment";
import { BaseModel } from "./model/BaseModel";

export class Api {
  card = new CardController();
  authOtp = new AuthOtpController();
  camunda = new CamundaController();
  reference = new ReferenceController();
  kato = new KatoController();
}

export interface OrderRequest {
  fio?: string;
  phoneNumber?: string;
}

function uuid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export class CardController {
  order(request: BaseModel) {
    const config: any = {};
    config.headers = config.headers || {};
    config.headers = {
      "x-ibm-client-id": "c274fb89-0d53-4304-95e9-130b267cd326",
    };
    config.baseURL = 'https://api.bcc.kz/bcc/production/v1';

    const data = {
      system: "EXTERNALSITE",
      requestId: uuid(),
      responseId: "c274fb89-0d53-4304-95e9-130b267cd326",
      route: "DeltaM",
      object: "ClaimAddRequest",
      timestamp: "1453526556",
      type: "REQUEST",
      attributes: {
        data: {
          type: "SMARTCALL",
          systemId: "aef8572a-c2ad-47ac-8506-985b0d39396e",
          name: `${request.lastName} ${request.firstName} ${request.middleName}`, //---------------------FIO
          phone: request.contactData ? request.contactData[0].phoneNumber : '', //------------PhoneNumber
          iinBin: request.taxIdentificationNumber?.code,
          organizationName: null,
          email: null,
          callTime: moment().format("HH:mm"), //--------------CallTime
          date: moment().format("DD-MM-YYYY"), //----------------------DateTime
          productService: {
            productName: "Ипотека Баспана-Хит",
            productCode: "0.201.1.1124",
            productDescription: "Получить пенсионные выплаты на улучшение жилищных условий"
          },
        },
      },
    };

    return axios
      .post(`/protected/callcenter/order`, data, config)
      .then((r) => r.data);
  }
}

export const api = new Api();
